import {getHeaders} from './localStorage';
import axios from 'axios';
import {api, versao} from '../config';
import errorHandling from './errorHandling';
import {
    GET_PRODUTOS,
    GET_PRODUTO,
    LIMPAR_PRODUTO
} from './types';

/** Monta query string de listagem com filtros opcionais (destaque, categoria, disponibilidade, estoque). */
export function buildProdutoListQuery(loja, atual, limit, sortType, filtros = {}) {
    const p = new URLSearchParams();
    p.set('loja', loja);
    p.set('offset', String(atual));
    p.set('limit', String(limit));
    p.set('sortType', sortType || 'decrescente');
    if (filtros.destaque === 'true' || filtros.destaque === 'false') {
        p.set('destaque', filtros.destaque);
    }
    if (filtros.categoria) {
        p.set('categoria', filtros.categoria);
    }
    if (filtros.disponibilidade === 'true' || filtros.disponibilidade === 'false') {
        p.set('disponibilidade', filtros.disponibilidade);
    }
    if (filtros.estoque === 'com' || filtros.estoque === 'sem') {
        p.set('estoque', filtros.estoque);
    }
    return p.toString();
}

export const getProdutos = (ordem, atual, limit, loja, filtros = {}) => {
    return function (dispatch) {
        const qs = buildProdutoListQuery(loja, atual, limit, ordem, filtros);
        axios.get(`${api}/${versao}/api/produtos?${qs}`, getHeaders())
            .then(response => dispatch({type: GET_PRODUTOS, payload: response.data}))
            .catch(errorHandling);
    }
}

export const getProdutosPesquisa = (termo, ordem, atual, limit, loja, filtros = {}) => {
    return function (dispatch) {
        const qs = buildProdutoListQuery(loja, atual, limit, ordem, filtros);
        axios.get(`${api}/${versao}/api/produtos/search/${encodeURIComponent(termo)}?${qs}`, getHeaders())
            .then(response => dispatch({type: GET_PRODUTOS, payload: response.data}))
            .catch(errorHandling);
    }
}

export const salvarProduto = (produto, loja, cb) => {
    const _amountPrice = String(produto.preco).replace("R$", "").replace(" ", "").replace(".", "").replace(",", "");
    const formattedPrice = Number(`${_amountPrice.slice(-11, -2)}.${_amountPrice.slice(-2)}`);

    const _amountPricePromotion = String(produto.promocao).replace("R$", "").replace(" ", "").replace(".", "").replace(",", "");
    let formattedPromotion = Number(`${_amountPricePromotion.slice(-11, -2)}.${_amountPricePromotion.slice(-2)}`);

    if (isNaN(formattedPromotion)) {
        formattedPromotion = 0;
    }
    return function (dispatch) {
        axios.post(`${api}/${versao}/api/produtos?loja=${loja}`, {
            titulo: produto.nome,
            quantidade: produto.quantidade,
            descricao: produto.descricao,
            categoria: produto.categoria,
            preco: formattedPrice,
            promocao: formattedPromotion,
            erpId: produto.erpId
        }, getHeaders())
            .then(response => {
                dispatch({type: GET_PRODUTO, payload: response.data});
                cb(null);
            })
            .catch((e) => cb(errorHandling(e)));
    }
}

export const getProduto = (id, loja, cb) => {
    return function (dispatch) {
        axios.get(`${api}/${versao}/api/produtos/${id}?loja=${loja}`, getHeaders())
            .then(response => {
                dispatch({type: GET_PRODUTO, payload: response.data});
                cb && cb(response.data);
            })
            .catch(errorHandling);
    }
}

export const limparProduto = () => ({type: LIMPAR_PRODUTO});

export const updateProduto = (produto, id, loja, cb) => {

    if (String(produto.preco).slice(0, 2) !== "R$") produto.preco = produto.preco.toFixed(2);
    const _amountPrice = String(produto.preco).replace("R$", "").replace(" ", "").replace(".", "").replace(",", "");
    const formattedPrice = Number(`${_amountPrice.slice(-11, -2)}.${_amountPrice.slice(-2)}`).toFixed(2);

    if (String(produto.promocao).slice(0, 2) !== "R$") produto.promocao = produto.promocao.toFixed(2);
    const _amountPricePromotion = String(produto.promocao).replace("R$", "").replace(" ", "").replace(".", "").replace(",", "");
    const formattedPromotion = Number(`${_amountPricePromotion.slice(-11, -2)}.${_amountPricePromotion.slice(-2)}`).toFixed(2);

    return function (dispatch) {
        axios.put(`${api}/${versao}/api/produtos/${id}?loja=${loja}`, {
            titulo: produto.nome,
            descricao: produto.descricao,
            disponibilidade: produto.disponibilidade === "disponivel" ? "true" : "false",
            destaque: produto.destaque,
            quantidade: produto.quantidade,
            categoria: produto.categoria,
            preco: formattedPrice,
            promocao: formattedPromotion,
            erpId: produto.erpId
        }, getHeaders())
            .then(response => {
                dispatch({type: GET_PRODUTO, payload: response.data});
                cb(null);
            })
            .catch(e => cb(errorHandling(e)));
    }
}

export const removeProdutoImagens = (fotos, removeImageFile, id, loja, cb) => {
    return function (dispatch) {
        axios.put(`${api}/${versao}/api/produtos/${id}?loja=${loja}`, {fotos, removeImageFile}, getHeaders())
            .then(response => {
                dispatch({type: GET_PRODUTO, payload: response.data});
                cb(null);
            })
            .catch(e => cb(errorHandling(e)));
    }
}

export const updateProdutoImagens = (data, id, loja, cb) => {
    return function (dispatch) {
        axios.put(`${api}/${versao}/api/produtos/images/${id}?loja=${loja}`, data, getHeaders())
            .then(response => {
                dispatch({type: GET_PRODUTO, payload: response.data});
                cb(null);
            })
            .catch(e => cb(errorHandling(e)));
    }
}

export const updateCategories = (categories, id, loja, cb) => {
    return function (dispatch) {
        axios.put(`${api}/${versao}/api/produtos/${id}/categories?loja=${loja}`, {categories}, getHeaders())
            .then(response => {
                dispatch({type: GET_PRODUTO, payload: response.data});
                cb(null)
                return;
            })
            .catch(e => cb(e));
    }
}
